
export default {
  name: 'SectionsCompetitorComparison',
  props: {
    competitorComparison: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    competitors() {
      const competitors =
        (this.competitorComparison && this.competitorComparison.competitors) ||
        []
      return competitors.filter(
        (item) => item && (this.hasLogo(item) || (item.name && String(item.name).trim()))
      )
    },
    comparisonLists() {
      return (
        (this.competitorComparison &&
          this.competitorComparison.comparisonLists) ||
        []
      )
    },
    isVisible() {
      return (
        this.competitorComparison &&
        this.competitorComparison.enabled !== false &&
        this.competitors.length > 0 &&
        this.comparisonLists.length > 0
      )
    },
    noteLines() {
      const note =
        this.competitorComparison && this.competitorComparison.note
      if (!note) return []
      return String(note)
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter(Boolean)
    },
  },
  mounted() {
    this.bindStickyHead()
  },
  beforeDestroy() {
    if (this.onScroll) {
      window.removeEventListener('scroll', this.onScroll)
      this.onScroll = null
    }
  },
  methods: {
    hasLogo(item) {
      return !!(item && item.logo && item.logo.url)
    },
    columnClass(index) {
      if (index === 0) return 'table-comparison-ours'
      if (index === 1) return 'table-bg-2'
      return 'table-bg-1'
    },
    bindStickyHead() {
      if (!this.$el || typeof this.$el.querySelector !== 'function') return

      const tableComparison = this.$el.querySelector('.table-comparison')
      const content = this.$el.querySelector('.table-content')
      const header = document.querySelector('.header')
      if (!tableComparison || !content) return

      this.onScroll = () => {
        const rect = tableComparison.getBoundingClientRect()
        const contentHeight = content.offsetHeight

        if (rect.top <= 20 && rect.bottom >= contentHeight) {
          tableComparison.classList.add('table-comparison-sticky', 'container')
          if (header) header.classList.add('d-none')
        } else {
          tableComparison.classList.remove(
            'table-comparison-sticky',
            'container'
          )
          if (header) header.classList.remove('d-none')
        }
      }

      window.addEventListener('scroll', this.onScroll)
    },
  },
}
